import { render } from "./VectorMapsHeader.vue?vue&type=template&id=0208af3e"
import script from "./VectorMapsHeader.vue?vue&type=script&lang=js"
export * from "./VectorMapsHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__